__turbopack_context__.v({
  "cta": "RuRlLG_cta",
  "ctaContainer": "RuRlLG_ctaContainer",
  "learnMore": "RuRlLG_learnMore",
  "primary": "RuRlLG_primary",
  "root": "RuRlLG_root",
  "sectionContent": "RuRlLG_sectionContent",
  "subText": "RuRlLG_subText",
  "textContent": "RuRlLG_textContent",
});
